var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeTrotters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Coliving/passion-3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M24.316 22.245c-.952 0-1.723.772-1.723 1.723v4.308c0 .952.771 1.723 1.723 1.723h11.2c.951 0 1.723-.771 1.723-1.723v-4.308c0-.951-.772-1.723-1.723-1.723h-11.2Zm.861 1.725a.215.215 0 0 0-.215.216v4.092c0 .119.096.215.215.215H35.3a.215.215 0 0 0 .215-.215v-4.092a.215.215 0 0 0-.215-.216H25.177Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M22.593 23.968c0-.951.771-1.723 1.723-1.723h11.2c.951 0 1.723.772 1.723 1.723v4.308c0 .952-.772 1.723-1.723 1.723h-11.2a1.723 1.723 0 0 1-1.723-1.723v-4.308Zm2.369.218c0-.12.096-.216.215-.216H35.3c.119 0 .215.097.215.216v4.092a.215.215 0 0 1-.215.215H25.177a.215.215 0 0 1-.215-.215v-4.092Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FF",
    fillRule: "evenodd",
    d: "M18 2.4a4.8 4.8 0 0 0-4.8 4.8V12a4.8 4.8 0 0 0 4.8 4.8h7.2A4.8 4.8 0 0 0 30 12V7.2a4.8 4.8 0 0 0-4.8-4.8H18ZM18 6a1.2 1.2 0 0 0-1.2 1.2v7.2a1.2 1.2 0 0 0 1.2 1.2h7.2a1.2 1.2 0 0 0 1.2-1.2V7.2A1.2 1.2 0 0 0 25.2 6H18Z",
    className: "svg-primary-light",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M18 3.6a3.6 3.6 0 0 0-3.6 3.6V12c0 1.075.471 2.04 1.218 2.7a2.43 2.43 0 0 1-.018-.3V7.2A2.4 2.4 0 0 1 18 4.8h7.2a2.4 2.4 0 0 1 2.4 2.4v7.2c0 .102-.006.202-.019.3A3.591 3.591 0 0 0 28.8 12V7.2a3.6 3.6 0 0 0-3.6-3.6H18Zm7.2 13.2H18a4.8 4.8 0 0 1-4.8-4.8V7.2A4.8 4.8 0 0 1 18 2.4h7.2A4.8 4.8 0 0 1 30 7.2V12a4.8 4.8 0 0 1-4.8 4.8Zm-8.4-9.6A1.2 1.2 0 0 1 18 6h7.2a1.2 1.2 0 0 1 1.2 1.2v7.2a1.2 1.2 0 0 1-1.2 1.2H18a1.2 1.2 0 0 1-1.2-1.2V7.2Zm13.653 39.602a2.908 2.908 0 1 0 0-5.815 2.908 2.908 0 0 0 0 5.815Zm.001-1.507a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M33.36 43.894a2.908 2.908 0 1 1-5.814 0 2.908 2.908 0 0 1 5.815 0Zm-1.506.001a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0ZM13.44 46.802a2.908 2.908 0 1 0 0-5.815 2.908 2.908 0 0 0 0 5.815Zm0-1.507a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M16.347 43.894a2.908 2.908 0 1 1-5.815 0 2.908 2.908 0 0 1 5.815 0Zm-1.507.001a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FF",
    d: "M9.67 14.06a3.446 3.446 0 0 1 3.447-3.446h17.66a3.446 3.446 0 0 1 3.447 3.446v24.553a3.446 3.446 0 0 1-3.446 3.446H13.116a3.446 3.446 0 0 1-3.446-3.446V14.06Z",
    className: "svg-primary-light"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M30.777 11.814h-17.66a2.246 2.246 0 0 0-2.247 2.246v24.553a2.246 2.246 0 0 0 2.247 2.246h17.66a2.246 2.246 0 0 0 2.247-2.246V14.06a2.246 2.246 0 0 0-2.247-2.246Zm-17.66-1.2A3.446 3.446 0 0 0 9.67 14.06v24.553a3.446 3.446 0 0 0 3.447 3.446h17.66a3.446 3.446 0 0 0 3.447-3.446V14.06a3.446 3.446 0 0 0-3.446-3.446H13.116Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEDF8",
    fillRule: "evenodd",
    d: "M17.592 17.076a.6.6 0 0 1 .6.6v17.969a.6.6 0 1 1-1.2 0V17.676a.6.6 0 0 1 .6-.6Zm4.308 0a.6.6 0 0 1 .6.6v17.969a.6.6 0 0 1-1.2 0V17.676a.6.6 0 0 1 .6-.6Zm4.307 0a.6.6 0 0 1 .6.6v17.969a.6.6 0 0 1-1.2 0V17.676a.6.6 0 0 1 .6-.6Z",
    className: "svg-primary",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeTrotters);
export default __webpack_public_path__ + "static/media/globe-trotters.554a09970bf79bddaf1556f235a3f1fe.svg";
export { ForwardRef as ReactComponent };